import { Chip } from '@mui/material'
import { styles } from './styles'
import type { MedComplexStatusProps } from './types'
import { MedComplexStatusEnum } from '@/api/models/medcomplex'

export const MedComplexStatus = ({
  medcomplexStatus,
}: MedComplexStatusProps) => {
  switch (medcomplexStatus) {
    case MedComplexStatusEnum.DRAFT:
      return (
        <Chip
          sx={{
            ...styles.chip,
            color: '#787878',
            borderColor: '#8E8E8E',
            backgroundColor: '#EEEEEE',
          }}
          variant={'outlined'}
          label={'Черновик'}
        />
      )
    case MedComplexStatusEnum.ACTIVE:
      return (
        <Chip
          sx={styles.chip}
          variant={'outlined'}
          color="success"
          label={'В работе'}
        />
      )
    case MedComplexStatusEnum.INACTIVE:
      return (
        <Chip
          sx={styles.chip}
          variant={'outlined'}
          color="error"
          label={'Не в сети'}
        />
      )
    case MedComplexStatusEnum.BLOCKED:
      return (
        <Chip
          sx={styles.chip}
          variant={'outlined'}
          color="error"
          label={'Заблокирован'}
        />
      )
    case MedComplexStatusEnum.INNER_BLOCKED:
      return (
        <Chip
          sx={styles.chip}
          variant={'outlined'}
          color="warning"
          label={'Внутренняя блокировка'}
        />
      )
    default:
      return (
        <Chip
          sx={styles.chip}
          variant={'outlined'}
          color="primary"
          label={'...'}
        />
      )
  }
}
